import PropTypes from "prop-types"
import { connect } from "react-redux"
import pick from "ramda/es/pick"
import { compose, withStateHandlers, withPropsOnChange } from "recompact"
import { requestValidate } from "src/engine/modules/validate/actions/creators"
import * as entity from "src/engine/modules/entity"
import hocInterface from "src/helpers/hocInterface"
import makeCompareFunction from "src/helpers/makeCompareFunction"
import planResources from "src/hocs/planResources"
import collection from "src/hocs/collection"
import planResourceModel from "src/models/plan/models/resource"

// Adds plan resources outplan highlighting
export default hocInterface(
  {
    injectProps: {
      planId: PropTypes.string.isRequired,
    },
    consumeProps: {
      // В группы добаляется индикатор того, что она не в плане
      groupsCache: PropTypes.arrayOf(PropTypes.object),
    },
    exposeProps: pick([`groupsCache`]),
  },
  compose(
    planResources({ to: `resourcesOutPlan`, view: `OUT_PLAN` }),
    connect(null, {
      requestValidate,
    }),
    withStateHandlers(
      {
        refreshTimestamp: Date.now(),
      },
      {
        refreshPlanResources: () => () => ({
          refreshTimestamp: Date.now(),
        }),
      },
    ),

    collection(({ refreshTimestamp, planId }) => ({
      engine: entity,
      to: `resourcesOutPlan`,
      model: planResourceModel(planId),
      query: {
        limit: -1,
        orderBy: `name asc`,
        view: `OUT_PLAN`,
        updated: refreshTimestamp,
      },
    })),

    // Проставление группам флага "вне плана"
    withPropsOnChange(
      makeCompareFunction([
        `groupsCache`,
        `resourcesOutPlan.data`,
        `resourcesOutPlan.pending`,
      ]),
      ({
        groupsCache,
        resourcesOutPlan: {
          data: resourcesOutPlan,
          pending: resourcesOutPlanPending,
        },
      }) => ({
        groupsCache: resourcesOutPlanPending
          ? groupsCache
          : groupsCache.map(group =>
              resourcesOutPlan.some(resource => resource.uuid === group.uuid)
                ? { ...group, offPlan: true }
                : group,
            ),
      }),
    ),
  ),
)
